// problems#show — the page is server-rendered except the discussion section,
// which is the React discuss app scoped to this problem.
import { registerPage } from "../first"
import { mountDiscussApp } from "../discuss_app"

export const ProblemsShowPage = {
  onDomReady(): void {
    mountDiscussApp()
  },
}

registerPage("ProblemsShowPage", ProblemsShowPage)
